function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  id: "svg_1",
  d: "m1664,960q-152,-236 -381,-353q61,104 61,225q0,185 -131.5,316.5t-316.5,131.5t-316.5,-131.5t-131.5,-316.5q0,-121 61,-225q-229,117 -381,353q133,205 333.5,326.5t434.5,121.5t434.5,-121.5t333.5,-326.5zm-720,-384q0,-20 -14,-34t-34,-14q-125,0 -214.5,89.5t-89.5,214.5q0,20 14,34t34,14t34,-14t14,-34q0,-86 61,-147t147,-61q20,0 34,-14t14,-34zm848,384q0,34 -20,69q-140,230 -376.5,368.5t-499.5,138.5t-499.5,-139t-376.5,-368q-20,-35 -20,-69t20,-69q140,-229 376.5,-368t499.5,-139t499.5,139t376.5,368q20,35 20,69z"
});

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1792 1792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.647d91e9.svg";
export { ForwardRef as ReactComponent };